import { render, staticRenderFns } from "./companySetting.vue?vue&type=template&id=6e042c9e&scoped=true&"
import script from "./companySetting.vue?vue&type=script&lang=js&"
export * from "./companySetting.vue?vue&type=script&lang=js&"
import style0 from "./companySetting.vue?vue&type=style&index=0&id=6e042c9e&scoped=true&lang=css&"
import style1 from "./companySetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e042c9e",
  null
  
)

export default component.exports